import React from 'react';
import { lazy } from 'react';
import { useSelector } from 'react-redux';

import Loadable from '../Loadable';

const AppLoaderOverlay = Loadable(lazy(() => import('../dialogs/AppLoaderOverlay')));
const PasswordEntryDialog = Loadable(lazy(() => import('../dialogs/PasswordEntryDialog')));
const PasswordResetDialog = Loadable(lazy(() => import('../dialogs/ResetPasswordDialog')));
const CoachingDialog = Loadable(lazy(() => import('../dialogs/CoachingDialog')));
const MarkAsServiceDialog = Loadable(lazy(() => import('../dialogs/MarkAsServiceDialog')));
const SessionExpiredDialog = Loadable(lazy(() => import('../dialogs/SessionExpiredDialog')));
const MoveDeviceConfirmationDialog = Loadable(lazy(() => import('../dialogs/MoveDeviceConfirmationDialog')));

const DialogOutlet = () => {
  const dialog = useSelector((state) => state.dialog);

  return (
    <>
      {dialog.openAppLoaderOverlay.open ? <AppLoaderOverlay /> : null}
      {dialog.openPasswordEntryDialog.open ? <PasswordEntryDialog /> : null}
      {dialog.openPasswordResetDialog.open ? <PasswordResetDialog /> : null}
      {dialog.openCoachingDialog.open ? <CoachingDialog /> : null}
      {dialog.openMarkAsServicedDialog.open ? <MarkAsServiceDialog /> : null}
      {dialog.openSessionExpiredDialog.open ? <SessionExpiredDialog /> : null}
      {dialog.openMoveDeviceConfirmationDialog.open ? <MoveDeviceConfirmationDialog {...dialog.openMoveDeviceConfirmationDialog.props} /> : null}
    </>
  );
};

export default DialogOutlet;
